"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5408],{

/***/ 28457:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ButtonTag; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/picture/picture-component.js + 3 modules
var picture_component = __webpack_require__(82305);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button-tag/default-props.js
/* harmony default export */ var default_props = ({
    tagImg: {
        src: "/static/img/button/pm.png"
    },
    tagText: "Project Management",
    link: ""
});

// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./segments/desktop/core-components/button-tag/button-tag.scss.js


var StyledButtonTag = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1jt1db40"
})("padding:7px 14px;.button-tag-anchor{height:52px;width:100%;cursor:pointer;display:flex;padding:0px 16px 0 8px;align-items:center;border-radius:2px;flex-direction:row;color:", colors/* default.tuna */.Z.tuna, ";font-size:0.875rem;text-decoration:none;background-color:", colors/* default.riverstone */.Z.riverstone, ";:hover{background-color:", colors/* default.snow */.Z.snow, ";}.tag-text{padding:0px 16px;align-items:center;}.button-tag-image{height:40px;}}");

;// CONCATENATED MODULE: ./segments/desktop/core-components/button-tag/button-tag.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var imageHeight = "40px";
var ButtonTag = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ButtonTag, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ButtonTag);
    function ButtonTag() {
        (0,_class_call_check/* default */.Z)(this, ButtonTag);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ButtonTag, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, tagImg = _props.tagImg, link = _props.link, tagText = _props.tagText, isOpenLinkInNewTab = _props.isOpenLinkInNewTab;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonTag, {
                    className: "button-tag",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: link,
                        target: isOpenLinkInNewTab ? "_blank" : "_self",
                        className: "button-tag-anchor",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(picture_component/* default */.Z, _object_spread_props(_object_spread({}, tagImg), {
                                specificImageStyle: {
                                    height: imageHeight
                                },
                                pictureClass: "button-tag-image",
                                isDecorative: true
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "tag-text",
                                children: tagText
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return ButtonTag;
}(react.PureComponent);

ButtonTag.defaultProps = default_props;


/***/ }),

/***/ 15408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ ButtonTagsGridComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./segments/desktop/core-components/button-tag/button-tag.js + 2 modules
var button_tag = __webpack_require__(28457);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-tags-grid/button-tags-grid-component.scss.js


var StyledButtonTagsGridComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1v4fqys0"
})("max-width:", vp_sizes/* MAX_DESKTOP_GRID_WIDTH */.sk, "px;width:100%;padding:16px;margin:auto;.grid-button-list{display:flex;flex-wrap:wrap;list-style-type:none;margin:0;padding:0;.grid-button-container{width:25%;}}@media (max-width:", vp_sizes/* MAX_DESKTOP_CONTENT_WIDTH */.O$, "px){.grid-button-list{.grid-button-container{width:33%;}}}@media (max-width:", vp_sizes.SM, "px){.grid-button-list{.grid-button-container{width:50%;}}}@media (max-width:", vp_sizes/* XS_M */.g4, "px){.grid-button-list{.grid-button-container{width:100%;font-size:0.875rem;}}}");

;// CONCATENATED MODULE: ./segments/desktop/grid/layouts/button-tags-grid/button-tags-grid-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




var ButtonTagsGridComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(ButtonTagsGridComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(ButtonTagsGridComponent);
    function ButtonTagsGridComponent() {
        (0,_class_call_check/* default */.Z)(this, ButtonTagsGridComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(ButtonTagsGridComponent, [
        {
            key: "renderButtonTags",
            value: function renderButtonTags() {
                var _props = this.props, gridButtonTags = _props.gridButtonTags, isOpenLinkInNewTab = _props.isOpenLinkInNewTab;
                return gridButtonTags.map(function(buttonTag, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "grid-button-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(button_tag/* default */.Z, _object_spread_props(_object_spread({}, buttonTag), {
                            isOpenLinkInNewTab: isOpenLinkInNewTab
                        }))
                    }, index);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButtonTagsGridComponent, {
                    className: "button-tags-grid-component",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                        className: "grid-button-list",
                        children: this.renderButtonTags()
                    })
                });
            }
        }
    ]);
    return ButtonTagsGridComponent;
}(react.PureComponent);

ButtonTagsGridComponent.defaultProps = {
    isOpenLinkInNewTab: true,
    gridButtonTags: [
        {
            tagImg: {
                src: "/static/img/button/pm.png"
            },
            tagText: "Project Management"
        },
        {
            tagImg: {
                src: "/static/img/button/software_dev.png"
            },
            tagText: "Software Developement"
        },
        {
            tagImg: {
                src: "/static/img/button/cs.png"
            },
            tagText: "Customer Support"
        },
        {
            tagImg: {
                src: "/static/img/button/hr.png"
            },
            tagText: "HR"
        },
        {
            tagImg: {
                src: "/static/img/button/m.png"
            },
            tagText: "Marketing"
        },
        {
            tagImg: {
                src: "/static/img/button/mediaproduction.png"
            },
            tagText: "Media and Production"
        },
        {
            tagImg: {
                src: "/static/img/button/opsit.png"
            },
            tagText: "Operations/IT"
        },
        {
            tagImg: {
                src: "/static/img/button/sales.png"
            },
            tagText: "Sales"
        }
    ]
};


/***/ })

}]);